class RedirectManager {
  constructor() {
    this.redirector = null;
  }
  register(redirector) {
    this.redirector = redirector;
  }
  redirect(to) {
    if (this.redirector) this.redirector(to);
  }
}

const instance = new RedirectManager();

export default instance;
